import { useAtomValue, useSetAtom } from 'jotai';
import { loaderState, userInfoAtom } from '../data/atoms/utilsAtoms';
import { toast } from 'react-toastify';
import { useCallback } from 'react';
import Toast from '../utils/toastManager';

export const useFormSubmit = onSubmitFunction => {
	const userData = useAtomValue(userInfoAtom);
	const setLoader = useSetAtom(loaderState);

	const onSubmitWithLoading = useCallback(
		async formData => {
			if (!userData?.token) {
				toast.error('Please login first');
				return;
			}
			try {
				setLoader(true);
				const token = userData.token;
				
				await onSubmitFunction(formData, token);
			} catch (error) {
				console.error('Error:', error);
				Toast.error(error.response.data.message || error.message  ||'Error during submission. Please try again.');
			} finally {
				setLoader(false);
			}
		},
		[onSubmitFunction, setLoader, userData.token]
	);

	return onSubmitWithLoading;
};
